module.exports = __webpack_public_path__ + "static/devices-603b65de110591b617486c743bfb7fe8.png";